"use client";

import { useId, useState } from "react";
import { ChevronDownIcon, InfoIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { TopSheen } from "./TopSheen";

/**
 * "Did you know?" disclosure.
 *
 * The export only ever shows this collapsed and never specifies the panel copy,
 * so the default paraphrases the helper text that sits above it rather than
 * asserting anything new. Pass `children` to supply the real copy.
 */
export function DidYouKnowDisclosure({ children }: { children?: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const panelId = useId();

  return (
    <div className="relative w-full">
      <TopSheen />
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-controls={panelId}
        className="flex h-[49px] w-full items-center justify-between rounded-lg bg-[#0F1319] px-6"
      >
        <span className="flex items-center gap-[10px]">
          <InfoIcon aria-hidden className="h-6 w-6 text-white" strokeWidth={1.5} />
          <span className="font-suisse-intl-medium text-base text-white">Did you know?</span>
        </span>
        <ChevronDownIcon
          aria-hidden
          className={cn("h-6 w-6 text-white transition-transform", open && "rotate-180")}
          strokeWidth={2.5}
        />
      </button>
      <div
        id={panelId}
        hidden={!open}
        className="mt-2 rounded-lg bg-[#0F1319] px-6 py-4 font-inter text-sm leading-[19.6px] text-[#9CA3AF]"
      >
        {children ??
          "Not sure which band you fall into? Start with the lowest plan — you can move up at any time as your expenses grow."}
      </div>
    </div>
  );
}
